export default {
  listaEventFields: [],
  eventField: {
    evento: {
      id: null,
      nome: null,
    },
    campo: {
      id: null,
      nome: null,
    },
    valor: "",
  },
};
